import { Directive, HostListener } from '@angular/core';
import { Validations } from '../constants/validations.constant';

@Directive({
  selector: '[alphaNumeric]'
})
export class AlphaNumericDirective {


  @HostListener('keydown', ['$event']) onInputChange(event:any) {
    const alphaNumericRegex = new RegExp(Validations.REGEX_ALPHANUMERIC_SPACES_HYPHEN);
    return alphaNumericRegex.test(event.key);
  }
}
